import {networkError} from "./ui";
import {
  deleteBidInvite$,
  getBidInvites$,
  getBidInvitesAccepted$,
  getBidInvitesDeclined$,
  getBidInvitesPending$
} from "../services/bids";
import * as R from "ramda";
import moment from "moment";

export const ADD_BID_CONTACTS = 'ADD_BID_CONTACTS';
export const addBidContacts = (contacts) => ({type: ADD_BID_CONTACTS, payload: contacts});
export const API_GET_BID_CONTACTS = 'API_GET_BID_CONTACTS';
// export const getBidContacts = (bidId, offset) => ({type: API_GET_BID_CONTACTS, payload: {bidId, offset}});
export const API_GET_BID_CONTACTS_DONE = 'API_GET_BID_CONTACTS_DONE';
export const getBidContactsDone = (response) => ({type: API_GET_BID_CONTACTS_DONE, payload: response});

export const getBidContacts = (bidId) => async (dispatch, getState) => {
  const cache = ({fetched = moment(), loading = true, error = null} = {}) => ({
    fetched,
    loading,
    error,
  });
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    let old_cache = R.path(['bidcontacts', 'data', bidId, 'cache'], getState()) || {};
    dispatch(addBidContacts([{...old_cache, bidid: bidId, contactuserid: 'cache', ...cache()}]));
    do {
      let { response, status } = await getBidInvites$({
        bidId,
        offset: nextOffset,
      }).toPromise();
      if (status === 204 || response === null) return;
      const { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addBidContacts(results));
        nextOffset = R.last(results).contactuserid;
      }
      old_cache = R.path(['bidcontacts', 'data', bidId, 'cache'], getState()) || {};
      dispatch(addBidContacts([{...old_cache, size, ...cache()}]));
    } while (soFar < theSize);
    old_cache = R.path(['bidcontacts', 'data', bidId, 'cache'], getState()) || {};
    dispatch(addBidContacts([{...old_cache, size: theSize, ...cache({loading: false})}]));
  } catch (error) {
    dispatch(networkError({ ...error, number: '10109-' + error.status }))
  }
};

export const DELETE_BID_CONTACT = 'DELETE_BID_CONTACT';
export const deleteBidContact = (bidId, userId) => ({ type: DELETE_BID_CONTACT, payload: { bidId, userId }});

export const removeBidContact = (bidId, userId) => async (dispatch, getState) => {
  try {
    await deleteBidInvite$({ bidId, userId }).toPromise();
    dispatch(deleteBidContact(bidId, userId));
  } catch (error) {
    dispatch(networkError({...error, number: '10004-'+error.status}));
  }
};

export const getBidContactStatusSummary = (bidId) => async (dispatch, getState) => {
  try {
    const { response: response_pending } = await getBidInvitesPending$({ bidId }).toPromise();
    const { response: response_accepted } = await getBidInvitesAccepted$({ bidId }).toPromise();
    const { response: response_declined } = await getBidInvitesDeclined$({ bidId }).toPromise();
    const old_cache = R.path(['bidcontacts', 'data', bidId, 'cache'], getState()) || {};
    const pending = (response_pending || {}).size || 0;
    const accepted = (response_accepted || {}).size || 0;
    const declined = (response_declined || {}).size || 0;
    dispatch(addBidContacts([{ ...old_cache, bidid: bidId, contactuserid: 'cache', pending, accepted, declined }]));
  } catch (error) {
    dispatch(networkError({...error, number: '10113-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/bidcontacts.js